import React, { useState, useEffect } from 'react';

const ScrollArrows = ({ containerRef }) => {
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);

    const checkScroll = () => {
        if (!containerRef.current) {
            console.log('ScrollArrows: No container ref');
            return;
        }
        const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
        console.log('ScrollArrows check:', { scrollLeft, scrollWidth, clientWidth, canScrollRight: scrollLeft < scrollWidth - clientWidth - 1 });
        setShowLeft(scrollLeft > 0);
        setShowRight(scrollLeft < scrollWidth - clientWidth - 1);
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            checkScroll();
            container.addEventListener('scroll', checkScroll);
            window.addEventListener('resize', checkScroll);
            const timer1 = setTimeout(checkScroll, 100);
            const timer2 = setTimeout(checkScroll, 500);
            const timer3 = setTimeout(checkScroll, 1000);

            const observer = new MutationObserver(checkScroll);
            observer.observe(container, { childList: true, subtree: true });

            return () => {
                container.removeEventListener('scroll', checkScroll);
                window.removeEventListener('resize', checkScroll);
                clearTimeout(timer1);
                clearTimeout(timer2);
                clearTimeout(timer3);
                observer.disconnect();
            };
        }
    }, [containerRef]);

    const scroll = (direction) => {
        if (containerRef.current) {
            containerRef.current.scrollBy({ left: direction * 200, behavior: 'smooth' });
        }
    };

    return (
        <>
            {showLeft && (
                <button 
                    onClick={() => scroll(-1)} 
                    style={{ 
                        position: 'absolute', 
                        left: '10px', 
                        top: '50%', 
                        transform: 'translateY(-50%)', 
                        zIndex: 1000, 
                        background: 'rgb(255 206 206 / 95%)', 
                        border: 'none', 
                        borderRadius: '50%', 
                        width: '48px', 
                        height: '48px', 
                        cursor: 'pointer', 
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#333',
                        transition: 'all 0.2s ease',
                        backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#D02F92';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(208, 47, 146, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
                        e.currentTarget.style.color = '#333';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                    }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </button>
            )}
            {showRight && (
                <button 
                    onClick={() => scroll(1)} 
                    style={{ 
                        position: 'absolute', 
                        right: '10px', 
                        top: '50%', 
                        transform: 'translateY(-50%)', 
                        zIndex: 1000, 
                        background: 'rgb(255 206 206 / 95%)', 
                        border: 'none', 
                        borderRadius: '50%', 
                        width: '48px', 
                        height: '48px', 
                        cursor: 'pointer', 
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#333',
                        transition: 'all 0.2s ease',
                        backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#D02F92';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(208, 47, 146, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
                        e.currentTarget.style.color = '#333';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                    }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            )}
        </>
    );
};

export default ScrollArrows;
